import { useMutation } from '@apollo/client/react'
import { Link, useNavigate } from '@faceup/router'
import { Button, Popconfirm } from '@faceup/ui-base'
import { Plan } from '@faceup/utils'
import { graphql } from '../__generated__'

const mutations = {
  closeReportMutation: graphql(`
    mutation CloseReportMutation($input: CloseReportInput!) {
      closeReport(input: $input) {
        closedCase {
          id
          ... on CompanyReport {
            id
            closed
          }
        }
      }
    }
  `),
}

type CloseReportButtonProps = {
  closed: boolean | null
  emailsSent: boolean | null
  id: string
  organizationalUnit: { isVerified: boolean | null; billing: { plan: Plan | null } | null }
}

export const CloseReportButton = ({
  closed,
  emailsSent,
  id,
  organizationalUnit: { isVerified, billing },
}: CloseReportButtonProps) => {
  const navigate = useNavigate()
  const [closeSchoolReport, { loading }] = useMutation(mutations.closeReportMutation, {
    onCompleted: () => navigate(routes => routes.reports()),
  })

  if (closed) {
    return null
  }

  if (!isVerified && billing?.plan !== Plan.Unregistered) {
    return (
      <>
        The institution is waiting for registration. Verify it on{' '}
        <Link to={routes => routes.schools()}>institution page</Link>.
      </>
    )
  }

  return (
    <Popconfirm
      title={<>Resolve{emailsSent ? null : <i>(E-mails were not sent!)</i>}</>}
      onConfirm={() =>
        closeSchoolReport({
          variables: {
            input: {
              caseId: id,
            },
          },
        })
      }
    >
      <Button type='primary' loading={loading}>
        Close report
      </Button>
    </Popconfirm>
  )
}
